/**
 * Deterministic pastel color for a clinic BSNR, used as a visual indicator
 * so tickets belonging to the same clinic share a consistent color.
 */
export const getBsnrColor = (bsnr?: string | null): string => {
  if (!bsnr) return "#bdbdbd";
  let hash = 0;
  for (let i = 0; i < bsnr.length; i++) {
    hash = bsnr.charCodeAt(i) + ((hash << 5) - hash);
    hash |= 0;
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 60%, 80%)`;
};

/**
 * Resolve the official BSNR to DISPLAY for a ticket (the value the BSNR filter
 * matches against). A ticket reaches a clinic only through its linked Rx.
 */
export const resolveTicketBsnr = (ticket?: {
  rx?: { BSNR?: string | null } | null;
} | null): string | null => {
  const rx = ticket?.rx;
  if (!rx) return null;
  return rx.BSNR || null;
};

/**
 * Resolve the internal clinic id (practice number) used to GROUP/SORT and color
 * tickets. Sorting and the visual grouping indicator key off this, not the BSNR.
 */
export const resolveTicketClinicId = (ticket?: {
  rx?: { clinicId?: string | null } | null;
} | null): string | null => {
  const rx = ticket?.rx;
  if (!rx) return null;
  return rx.clinicId || null;
};

